// stores/useViewedAdsStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';



export const useViewedAdsStore = create()(
  persist(
    (set, get) => ({
      viewedAdIds: [],
      markAdAsViewed: (id) => {
        const current = get().viewedAdIds;
        if (!current.includes(id)) {
          set({ viewedAdIds: [...current, id] });
        }
      },
      resetViewedAds: () => set({ viewedAdIds: [] }),
    }),
    {
      name: 'viewed-ads-storage', // localStorage key
    }
  )
);
